import React from "react";
import styles from "./agencias.module.css";
import Titulo from "../titulo/titulo";
import Agencia from "../agencia/agencia";

const Agencias = ({ codigo }) => {
    return (
        <div className={styles.container}>
            <Titulo
                titulo="Pago en Agencias y Agentes"
            />

            <div className={styles.tabla_agencias}>
                <div className={styles.banco}>
                    <Agencia
                        descripcion={'Acércate a la agencia de tu preferencia.<br/><label style="color: #0071BC">BCP - BBVA - Interbank - Scotiabank - Caja Trujillo - Caja Tacna</label><br/>Indique que pagará al servicio "SafetyPay" (No a Pacifico Vida)<br/>con el código de pago <label style="color: #24A6C8">' + codigo + '</label>.'}
                    />
                </div>

                <div className={styles.banco}>
                    <Agencia
                        descripcion={'<label style="color: #0071BC">BCP Agente:</label> Mencione el código de empresa 03630 y luego tu código de pago <label style="color: #24A6C8">' + codigo + '</label>.<br/><label style="color: #0071BC">Interbank Agente:</label> Mencione el código de empresa 27114<br/>y luego tu código de pago <label style="color: #24A6C8">' + codigo + '</label>.<br/><label style="color: #0071BC">Agentes Express BBVA y Kasnet</label> Paga al Servicio SafetyPay<br/>dando tu código de pago <label style="color: #24A6C8">' + codigo + '</label>.'}
                    />
                </div>
            </div>
        </div>
    )
}

export default Agencias;